export class PoolStatusResponse {
  status: string;
}
